export default __webpack_public_path__ + "static/technology_w-eb8f88877e8f4dc23d55debd17749f14.webp";